import React from 'react';
import * as d3 from 'd3';
// import { rgb } from 'd3-color';
// import { scaleLinear, scaleBand } from 'd3-scale';
// import {Typography} from '@material-ui/core';
// import { BorderColor } from '@material-ui/icons';

export default (props) => {
  const { marker, size, color } = props;

  const leftTextWidth = 30;
  const rightTextWidth = 30;
  const adjustedWidth = size.width - (leftTextWidth + rightTextWidth);
  const lineHeight = 50;
  const piePadding = 1;

  const hundreds = d3.range(Math.floor(marker.value / 100));
  const remainder = marker.value % 100;

  let piesData = [];

  const makePie = (percent) => {
    if (percent === 100) return [{ name: 'full', value: percent }];
    else
      return [
        { name: 'empty', value: 100 - percent },
        { name: 'full', value: percent },
      ];
  };

  for (let i = 0; i < hundreds.length; i++) {
    piesData.push(makePie(100));
  }

  piesData.push(makePie(remainder));

  const numPies = piesData.length;
  const radius =
    15 < (0.5 * adjustedWidth) / numPies - piePadding
      ? 15
      : (0.5 * adjustedWidth) / numPies - piePadding;

  const arc = d3.arc().innerRadius(0).outerRadius(radius);
  // .startAngle(3 * Math.PI / 4)
  // .endAngle(Math.PI / 4);

  // const scaleX = scaleBand().domain(sortedData.map((d) => d.index)).range([0, adjustedWidth]).padding(barPadding);
  // const scaleY = scaleLinear().domain([0, 100]).range([0,lineHeight]);

  return (
    <div style={{ display: 'flex' }}>
      {/* <Typography variant="h6" color="primary" style={{paddingTop:(lineHeight/2-lineThickness)}}> </Typography> */}
      {numPies > 0 ? (
        <div
          style={{
            paddingLeft: leftTextWidth + 'px',
            paddingRight: rightTextWidth + 'px',
          }}
        >
          <svg className="lineMarker" width={adjustedWidth} height={lineHeight}>
            <g className="lineMarkerG" height={lineHeight}>
              {piesData.map((pie, i) => {
                return (
                  <g
                    classname={'pie' + i}
                    transform={
                      'translate(' +
                      (adjustedWidth / (2 * numPies) +
                        i * (adjustedWidth / numPies)) +
                      ',' +
                      lineHeight / 2 +
                      ')'
                    }
                  >
                    {d3
                      .pie()
                      .sort(null)
                      .value((d) => +d.value)(pie)
                      .map((slice, j) => {
                        return (
                          <path
                            d={arc(slice)}
                            stroke={color.primary}
                            fill={
                              slice.data.name === 'full'
                                ? color.primary
                                : color.secondary
                            }
                            strokeWidth={1}
                            key={'pieSlice' + j}
                          ></path>
                        );
                      })}
                  </g>
                );
              })}
            </g>
          </svg>
        </div>
      ) : null}

      {/* <Typography variant="h6" color="primary" style={{paddingTop:(lineHeight/2-lineThickness)}}> </Typography> */}
    </div>
  );
};
